(function () {
    'use strict';
    var controllerId = 'commessaAdd';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', '$uibModalInstance', 'datacontext', 'common', 'commessa', '$translate', commessaAddFn]);

    function commessaAddFn($scope, $rootScope, $uibModalInstance, datacontext, common, commessa, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.commessa = commessa;
        getCodiceCommessa();
        $scope.item = {};
        $scope.item.clienti = getClienti();   
        $scope.disableSave = false;

        $scope.item.isPersonale = $rootScope.isAuthorized('PERSONALE');

        //datapicker        
        $scope.open1 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = !$scope.opened1;
            $scope.opened2 = false;
        };
        $scope.open2 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened2 = !$scope.opened2;
            $scope.opened1 = false;
        };        

        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        $scope.format = 'dd/MM/yyyy';

        $scope.ok = function (isValid) {
            if (isValid) {
                addItem($scope.commessa).then(function (result) {
                    if (result.Id && result.Id > 0)
                        $uibModalInstance.close(result);
                });
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function getCodiceCommessa() {            
            return datacontext.commessa_getMaxCodiceCommessa().then(function (codice) {
                if (codice) {                    
                    $scope.commessa.Codice = codice;
                }
                else
                    logError($translate.instant('Impossibile ricavare il codice commessa'));
            });
        }

        // Aggiunta elemento
        function addItem(item) {     
            $scope.disableSave = true;
            item.Stato = 3;

            return datacontext.commessa_add(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) {
                    logError($translate.instant('Errore durante la creazione del dato'));            // In questo caso l'aggiunta non è andata a buon fine
                    return null;
                }

                $scope.disableSave = false;
                return data;
            });
        }

        function getClienti() {
            datacontext.cliente_getAllList().then(function (data) {
                return $scope.item.clienti = data;
            });
        }
    }
})();